
<template>
  <!--钥匙分配-->
  <div class="step-form">
    <a-steps class="steps" :current="currentStep" :status="stepStatus">
      <a-step v-for="item in steps" :key="item.title" :title="item.title" />
    </a-steps>

    <a-form class="content" :form="form">
      <template v-if="currentStep===0">
        <a-form-item v-bind="$store.state.step_ItemLayout" label="小区" has-feedback>
          <a-select
            v-decorator="['community_id', decoratorOptions.community_id]"
            :filterOption="filterOption"
            allowClear
            showSearch
            placeholder="请选择小区">
            <a-select-option v-for="(item, index) of communityList" :key="index" :value="item.value">
              {{item.label}}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-bind="$store.state.step_ItemLayout" label="账号" has-feedback>
          <a-input v-decorator="['mobile', decoratorOptions.mobile]" placeholder="请输入手机"/>
        </a-form-item>
      </template>

      <template v-if="currentStep===1">
      <a-form-item v-bind="$store.state.step_ItemLayout" label="小区">
        <span class="ant-form-text">{{roomData.community_name}}</span>
      </a-form-item>

        <a-form-item v-bind="$store.state.step_ItemLayout" label="账号">
          <span class="ant-form-text">{{roomData.mobile}}</span>
        </a-form-item>

        <a-form-item v-bind="$store.state.step_ItemLayout" label="房间">
          <p
            class="ant-form-text"
            :style="{display: 'block'}"
            v-for="(item, index) of roomData.room_list"
            :key="index"
          >{{item.room_name}}</p>
        </a-form-item>

        <a-form-item label="设备列表" v-bind="$store.state.step_ItemLayout">
          <a-transfer
            :listStyle="{ width: '230px', height: '300px' }"
            v-decorator="['door_eq_ids', decoratorOptions.door_eq_ids]"
            @change="transferChange"
            :dataSource="dataSource"
            :titles="['可选设备', '已选设备']"
            :targetKeys="targetKeys"
            showSearch
            :filterOption="transferFilter"
            :render="item => item.title"
          />
        </a-form-item>
      </template>

      <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
        <div class="steps-action">
          <a-button v-if="currentStep < steps.length - 2" type="primary" @click="next" size="large">下一步</a-button>
          <a-button v-if="currentStep === steps.length - 2" type="primary" @click="handleSubmit" size="large">立即分配</a-button>
          <a-button v-if="currentStep>0" :style="{marginLeft: '8px'}" @click="currentStep--" size="large">上一步</a-button>
        </div>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import mixin from '../../../js/mixins';
import empty from '../../../js/empty';
export default {
  mixins: [mixin.inputSearch, mixin.fetchSelect, mixin.addEdit],
  name: 'allocation',
  data () {
    return {
      roomData: {},
      formValues: {},
      targetKeys: [],
      currentStep: 0,
      stepStatus: 'process',
      steps: [{ title: '填写账号信息' }, { title: '确认分配钥匙' }, { title: '完成' }],
      dataSource: [],
      communityList: [],
      decoratorOptions: {
        community_id: {
          rules: [{ required: true, message: '请选择小区' }]
        },
        mobile: {
          rules: [
            { required: true, message: '请输入手机号' },
            { pattern: this.REG.mobile, message: this.MESSAGE.mobile }
          ]
        },
        door_eq_ids: {
          rules: [{ required: true, message: '请选择设备' }]
        }
      }
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  mounted () {
    this.communitySelect((data) => {
      this.communityList = data;
    }, null, 1);
  },
  methods: {
    /* 下一步 */
    next () {
      let fieldNames = [['community_id', 'mobile']];
      this.form.validateFields(fieldNames[this.currentStep], (err, values) => {
        if (err) {
          this.stepStatus = 'error';
          return false;
        } else {
          this.$post({
            url: '/key_list/authentication',
            params: values
          }).then(({data}) => {
            this.stepStatus = 'process';
            this.formValues = {...this.formValues, ...values};
            this.currentStep++;
            this.roomData = data;
            let arr = [];
            data.device_list.forEach((el) => {
              arr.push({
                key: `${el.door_eq_id}`,
                title: el.door_eq_name,
                disabled: false
              });
            });
            this.dataSource = arr;
          });
        }
      });
    },
    /* 表单提交 */
    handleSubmit  () {
      this.form.validateFields((err, values) => {
        values = {...values, ...this.formValues};
        values.door_eq_ids = values.door_eq_ids.join(',');
        if (err) {
          this.stepStatus = 'error';
          return false;
        } else {
          this.$post({
            url: '/key_list',
            params: values
          }).then((res) => {
            empty.$emit('setAliveComponent');
            this.stepStatus = 'finish';
            this.targetKeys = [];
            this.$message.success(`${res.msg}`).then((res) => {
              this.$router.go(-1);
            });
          });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/device/keyList/allocation.vue